/**
 * Cities supported by Kiltro Scout.
 * The slug is the URL path: /ciudad/<slug>
 *
 * Adding a new city = add a row here. Once a venue with `city: "<displayName>"`
 * exists in the DB, it appears automatically on its landing.
 */
export const CITIES = {
  santiago: {
    slug: "santiago",
    displayName: "Santiago",
    fullName: "Santiago de Chile",
    country: "Chile",
    countryCode: "CL",
    flag: "🇨🇱",
    center: [-70.6483, -33.4569],
    zoom: 11.5,
    tagline: "La capital cervecera de Latinoamérica",
    description:
      "Más de 200 cervecerías artesanales hicieron de Santiago la capital cervecera del Cono Sur. Mapa, rutas, Huesos y los datos que el resto no se atreve a publicar.",
    isLive: true,
  },
  valparaiso: {
    slug: "valparaiso",
    displayName: "Valparaíso",
    fullName: "Valparaíso",
    country: "Chile",
    countryCode: "CL",
    flag: "🇨🇱",
    center: [-71.6127, -33.0472],
    zoom: 12.5,
    tagline: "Cerro, niebla y cerveza",
    description:
      "El puerto más rebelde de Chile prepara su escena craft. Pronto abrimos rutas por los cerros para tomar IPA con vista al mar.",
    isLive: false,
  },
  valdivia: {
    slug: "valdivia",
    displayName: "Valdivia",
    fullName: "Valdivia",
    country: "Chile",
    countryCode: "CL",
    flag: "🇨🇱",
    center: [-73.2459, -39.8142],
    zoom: 13,
    tagline: "Cuna cervecera de Sudamérica",
    description:
      "Donde nació la tradición artesanal chilena. Kunstmann, Bundor, Camba y todo el ecosistema valdiviano. Llegamos pronto.",
    isLive: false,
  },
  concepcion: {
    slug: "concepcion",
    displayName: "Concepción",
    fullName: "Concepción",
    country: "Chile",
    countryCode: "CL",
    flag: "🇨🇱",
    center: [-73.0498, -36.8270],
    zoom: 12.5,
    tagline: "Bío-Bío craft",
    description:
      "La escena cervecera del Bío-Bío crece a otra velocidad. Ya estamos hablando con los locales — pronto en Kiltro Scout.",
    isLive: false,
  },
  buenosaires: {
    slug: "buenosaires",
    displayName: "Buenos Aires",
    fullName: "Buenos Aires",
    country: "Argentina",
    countryCode: "AR",
    flag: "🇦🇷",
    center: [-58.3816, -34.6037],
    zoom: 12,
    tagline: "El Palermo cervecero",
    description:
      "Argentina te espera con cervecerías que están entre las mejores del mundo. Próxima parada de la camada Kiltro.",
    isLive: false,
  },
  lima: {
    slug: "lima",
    displayName: "Lima",
    fullName: "Lima",
    country: "Perú",
    countryCode: "PE",
    flag: "🇵🇪",
    center: [-77.0428, -12.0464],
    zoom: 12,
    tagline: "Barranco, Miraflores y la nueva ola peruana",
    description:
      "La nueva ola craft peruana tiene a Lima como epicentro. Te avisamos cuando aterrice Kiltro Scout en Perú.",
    isLive: false,
  },
};

export const CITY_LIST = Object.values(CITIES);
